import {
  Alert,
  Badge,
  Button,
  Checkbox,
  Col,
  Flex,
  Form,
  Input,
  InputNumber,
  Modal,
  Radio,
  Row,
  Space,
  Table,
} from 'antd';
import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { IRootStoreProps, WithoutStore, withStore } from '../../../stores';
import { IUserData, UserRoleEnum } from '../../user';
import { TransactionTypeEnum } from '../store';
import dayjs from 'dayjs';
import Text from 'antd/es/typography/Text';

const { Search } = Input;

class _Users extends Component<IRootStoreProps> {
  componentDidMount(): void {
    this.props.store.console.getUsers();
    this.props.store.console.getTotalFee();
  }

  render() {
    const { store } = this.props;

    const columns = [
      { title: 'Email', dataIndex: 'email', key: 'email', sorter: true },
      { title: 'Login', dataIndex: 'login', key: 'login', sorter: true },
      {
        title: 'Роли',
        dataIndex: 'roles',
        key: 'roles',
        sorter: true,
        render: (i: UserRoleEnum[], item: IUserData) => (
          <Button onClick={() => store.console.openRolesModal(item)}>Изменить</Button>
        ),
      },
      { title: 'Баланс', dataIndex: 'balance', key: 'balance', sorter: true },
      { title: 'Заблокировано', dataIndex: 'lockedBalance', key: 'lockedBalance', sorter: true },
      {
        title: 'Зарегистрирован',
        dataIndex: 'createdAt',
        key: 'createdAt',
        sorter: true,
        render: (time: string) => <Text>{dayjs(time).format('DD MMMM HH:mm')}</Text>,
      },
      {
        title: '',
        dataIndex: 'userId',
        key: 'userId',
        render: (userId: string, item: IUserData) => (
          <Badge count={item.transactionsPanding?.length} offset={[-5, 10]}>
            <Button
              type="primary"
              onClick={() => store.console.showTransferModal(item)}
              disabled={item.roles?.includes(UserRoleEnum.ADMIN)}
              style={{ marginBlock: 10 }}
            >
              Перевести
            </Button>
          </Badge>
        ),
      },
    ];

    return (
      <>
        <div>
          <Search
            placeholder="Поиск по имени или Email"
            onSearch={store.console.onSearch}
            allowClear
            enterButton
            style={{ width: 300, marginBottom: 16 }}
          />
          <Space style={{ marginLeft: 30 }}>
            <Text>{`%% всего: `}</Text>
            <Text style={{ fontWeight: 600 }}>{store.console.fee?.totalFee}</Text>

            <Text>{`Из них отправлено рефералам: `}</Text>
            <Text style={{ fontWeight: 600 }}>{store.console.fee?.totalFeeRef}</Text>
          </Space>
          <Table
            columns={columns}
            dataSource={store.console.users}
            loading={store.loading}
            pagination={{ total: store.console.totalUsers, pageSize: store.console.tableParams.limit }}
            onChange={store.console.handleTableChange}
          />
        </div>
        <Modal
          title={store.console.selectedUser?.email}
          open={store.console.isShowModal}
          footer={null}
          onCancel={store.console.closeTransferModal}
          loading={store.loading}
        >
          <Form
            initialValues={{ amount: 10, typeTransaction: TransactionTypeEnum.DEPOSIT }}
            layout="horizontal"
            onFinish={store.console.sendTransaction}
            style={{ maxWidth: 600 }}
          >
            <Form.Item label="Тип: " name="typeTransaction">
              <Radio.Group disabled={!!store.console.transactionsPandingID}>
                <Radio value={TransactionTypeEnum.DEPOSIT}>Пополнить</Radio>
                <Radio value={TransactionTypeEnum.WITHDRAWAL}>Вывести</Radio>
              </Radio.Group>
            </Form.Item>
            {store.console.selectedUser?.transactionsPanding?.length && (
              <>
                <Text>{'Заявки на вывод:'}</Text>
                <Form.Item name="transactionsPanding">
                  <Radio.Group onChange={e => store.console.setTransactionsPandingID(e.target.value)}>
                    <Flex vertical>
                      {store.console.selectedUser?.transactionsPanding.map(item => (
                        <>
                          <Radio key={item.transactionId} value={item.transactionId}>
                            {`${dayjs(item.createdAt).format('DD.MM.YY HH:mm')} - $${item.amount} | ${
                              item.balanceWitdrawal.currency
                            }`}
                          </Radio>
                          <Text style={{ fontSize: 14, marginLeft: 25 }}>{item.balanceWitdrawal.wallet}</Text>
                        </>
                      ))}
                    </Flex>
                  </Radio.Group>
                </Form.Item>
              </>
            )}
            <Form.Item
              label="Сумма"
              name="amount"
              rules={[
                { required: true, message: 'Пожалуйста, введите сумму!' },
                {
                  validator: (_, value) =>
                    value > 0 ? Promise.resolve() : Promise.reject(new Error('Сумма должна быть больше нуля!')),
                },
              ]}
            >
              <InputNumber disabled={!!store.console.transactionsPandingID} style={{ width: '100%' }} />
            </Form.Item>
            <Flex gap="small" wrap justify={'flex-end'}>
              <Button onClick={store.console.closeTransferModal}>Отмена</Button>
              <Button type="primary" htmlType="submit" loading={store.loading}>
                Отправить
              </Button>
            </Flex>
            {store.requestError && <Alert message="Error" description={store.requestError} type="error" showIcon />}
          </Form>
        </Modal>

        <Modal
          title={'Роли пользователя'}
          open={store.console.isShowRolesModal}
          footer={null}
          onCancel={store.console.closeRolesModal}
          loading={store.loading}
        >
          <Row>
            {Object.values(UserRoleEnum).map(role => {
              return (
                <Col span={12} key={role}>
                  <Checkbox
                    disabled={store.loading || role === UserRoleEnum.ADMIN}
                    onChange={e => store.console.addUserRole(e.target.value)}
                    value={role}
                    style={{ lineHeight: '32px' }}
                    checked={store.console.selectedUser?.roles?.includes(role)}
                  >
                    {role}
                  </Checkbox>
                </Col>
              );
            })}
          </Row>
          <Flex gap="small" wrap justify={'flex-end'}>
            <Button onClick={store.console.closeRolesModal}>Отмена</Button>
            <Button type="primary" htmlType="submit" loading={store.loading} onClick={store.console.updateRolesUser}>
              Сохранить
            </Button>
          </Flex>
          {store.requestError && <Alert message="Error" description={store.requestError} type="error" showIcon />}
        </Modal>
      </>
    );
  }
}

export const UsersPage: WithoutStore = withStore(observer(_Users));
